<app-breadcrumb *ngIf="!disableBreadcrumb" [master]="'Rejestracje'" [parentName]="'Identyfikatory'" [name]="'Lista importów'"></app-breadcrumb>
<div class="identifier-list-container">
  <form *ngIf="!disableFilters" (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="identifier-list-filters">
    <mat-form-field appearance="standard" class="identifier-list-filter">
      <mat-label>Typ akcji</mat-label>
      <mat-select
        [(ngModel)]="initialFilters.importType" name="importType"
      >
        <mat-option [value]="0">Import identyfikatorów</mat-option>
        <mat-option [value]="1">Import loginów Chronie.pl</mat-option>
        <mat-option [value]="2">Import danych Hiperio</mat-option>
        <mat-option [value]="3">Wysyłka identyfikatorów</mat-option>
        <mat-option [value]="4">Import linków afiliacyjnych</mat-option>
      </mat-select>
    </mat-form-field>

    <app-dict-insurance-companies
      (selectedInsuranceCompanies)="insuranceCompanyFilterChanged($event)"
      *ngIf="insuranceCompanyId === null" [multiple]="true"
      label="TU" class="identifier-list-filter"
      [(ngModel)]="initialFilters.insuranceCompany" name="insuranceCompany"
    ></app-dict-insurance-companies>

    <app-dict
      [multiple]="false" label="Firma"
      class="identifier-list-filter"
      dictType="company"
      [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>
    <mat-form-field appearance="standard" class="identifier-list-filter">
      <mat-label>Zmiana na "Zarejestrowana"</mat-label>
      <mat-select
        [(ngModel)]="initialFilters.changeToRegistered" name="changeToRegistered"
      >
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="standard" class="identifier-list-filter">
      <mat-label>Zmiana na "Wyrejestrowana"</mat-label>
      <mat-select
        [(ngModel)]="initialFilters.changeToDeregistered" name="changeToDeregistered"
      >
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
    <app-datepicker
      class="identifier-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>
    <app-datepicker
      class="identifier-list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>
    <app-dict-users
      label="Użytkownik"
      class="identifier-list-filter"
      [(ngModel)]="initialFilters.createdBy" name="createdBy"
    ></app-dict-users>
    <app-dict
      [multiple]="false" label="Status"
      class="identifier-list-filter"
      dictType="import_status"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>
  </form>
  <div *ngIf="!disableFilters" class="identifier-list-buttons"  fxLayout="row" fxLayoutAlign="space-between" >
    <div >
      <button  *ngIf="!protocolOpened"  mat-raised-button color="primary" (click)="openProtocol()" ><mat-icon>send</mat-icon>  Wyślij identyfikatory</button>
      <button  *ngIf="protocolOpened" mat-raised-button color="primary" (click)="sendImportsReport()"><mat-icon>send_and_archive</mat-icon>  Potwierdź i wyślij</button>
      <button  *ngIf="protocolOpened" (click)="cancel()" mat-raised-button color="warn"><mat-icon>cancel_schedule_send</mat-icon> <span>  Anuluj</span></button>

    </div>
    <div>
      <button *ngIf="(userPermissions | async).registration.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).registration.read_report"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>
  <table mat-table [dataSource]="imports">
    <ng-container matColumnDef="select"  >
      <th mat-header-cell *matHeaderCellDef>
        <!--        <mat-checkbox (change)="$event ? toggleAllRows() : null"
                              [checked]="selection.hasValue() && isAllSelected()"
                              [indeterminate]="selection.hasValue() && !isAllSelected()"
                              [aria-label]="checkboxLabel()">
                </mat-checkbox>-->
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          *ngIf="!row.hiperioData && !row.chronieLogin && !row.affiliateLinks && this.protocolOpened && row.progress === 100 && row.fullReport === false"
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="isSelect(row.uuid)"
          [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="importType">
      <th mat-header-cell *matHeaderCellDef> Typ akcji </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.chronieLogin">
          Import loginów Chronie.pl
        </ng-container>
        <ng-container *ngIf="element.hiperioData">
          Import danych Hiperio
        </ng-container>
        <ng-container *ngIf="element.shippingReport">
          Wysyłka identyfikatorów
        </ng-container>
        <ng-container *ngIf="!element.hiperioData && !element.chronieLogin && !element.shippingReport && !element.affiliateLinks">
          Import identyfikatorów
        </ng-container>
        <ng-container *ngIf="element.affiliateLinks">
          Import linków afiliacyjnych
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
        {{element.company?.name}}
      </td>
    </ng-container>
    <ng-container matColumnDef="linkName">
      <th mat-header-cell *matHeaderCellDef> Nazwa linku </th>
      <td mat-cell *matCellDef="let element">
        {{element.company?.name}}
      </td>
    </ng-container>
    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
          {{element.insuranceCompany.name}}
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
          {{element.insuranceCompany.name}}
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="affiliateLink">
      <th mat-header-cell *matHeaderCellDef> Link afiliacyjny </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
          {{element.insuranceCompany.name}}
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
          {{element.insuranceCompany.name}}
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="changeToRegistered" >
      <th mat-header-cell *matHeaderCellDef style="text-align: center"> Zmiana na <br>"Zarejestrowana" </th>
      <td mat-cell *matCellDef="let element" style="text-align: center">
        {{element.changeToRegistered ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>
    <ng-container matColumnDef="changeToDeregistered">
      <th mat-header-cell *matHeaderCellDef style="text-align: center" > Zmiana na <br>"Wyrejestrowana" </th>
      <td mat-cell *matCellDef="let element" style="text-align: center">
        {{element.changeToDeregistered ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>
    <ng-container matColumnDef="fullReport">
      <th mat-header-cell *matHeaderCellDef style="text-align: center">  Pełny raport </th>
      <td mat-cell *matCellDef="let element" style="text-align: center">
        {{element.fullReport ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>
    <ng-container matColumnDef="sentAt">
      <th mat-header-cell *matHeaderCellDef> Data wysłania </th>
      <td mat-cell *matCellDef="let element">
        {{element.sentAt | date:'dd-MM-y'}}
      </td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>
    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <div class="circular-image">
            <img class="circular-image small-avatar import-list-avatar"
                 [src]="'/rest/sso/api/user/' + element.createdBy.uuid + '/avatar'" (error)="onImgError($event)"
                 alt="Zdjęcie"/>
          </div>
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.firstName}} {{element.createdBy.lastName}}</a>
        </ng-container>
        <ng-container *ngIf="!element.createdBy">
          System
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
          <ng-container *ngIf="element.status.key === IMPORT_STATUS_IN_PROGRESS">
            ({{element.progress}}%)
          </ng-container>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button mat-menu-item (click)="showResult(element) " >Pokaż wynik</button>
          <button mat-menu-item *ngIf="!element.shippingReport"(click)="downloadImportFile(element)">Pobierz plik importu</button>
          <button mat-menu-item *ngIf="element.shippingReport"(click)="downloadImportFile(element)">Pobierz plik wysyłki</button>
          <button mat-menu-item (click)="downloadBackup(element)" [disabled]="!element.backupLocation">Pobierz backup</button>
          <button mat-menu-item *ngIf="!element.shippingReport">Ilość rekordów: {{element.importRow}}</button>
          <button mat-menu-item *ngIf="element.shippingReport" >Ilość maili: {{element.importRow}}</button>
        </mat-menu>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
<!--    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>-->
    <tr mat-row *matRowDef="let row; columns: displayedColumns; let element" [class.disabled-import]=" element.sentAt !== null || element.shippingReport"> </tr>

  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
